import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { Content, Section } from "../styles/Common";
import { styled } from "styled-components";
import Switch from "../components/setting/SwitchBtn";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../store/slices/authSlice";
import { getToken, returnLoginStatus } from "../components/hooks/authFunc";
import { ReactComponent as IcoArrow } from "../styles/images/ico_arrow.svg";
import { userActions } from "../store/slices/userSlice";
import { FuncModal, Modal } from "../components/modal/Modal";
import useDidMountEffect from "../components/hooks/useDidMountEffect";
import OnlyHeaderLayout from "../components/layout/OnlyHeaderLayout";
import { checkMobile } from "../components/hooks/basicFunc";

const SettingPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [openFuncModal, setOpenFuncModal] = useState(false);
  const [openCancelModal, setOpenCancelFuncModal] = useState(false);
  const [settingMode, setSettingMode] = useState(false);
  const [settingItem, setSettingItem] = useState("");
  const [version, setVersion] = useState("");
  const modalMsg = useSelector((state) => state.user.modalMsg);
  const userSettingInfo = useSelector((state) => state.user.userSetting);
  const userSettingUpdateSuccess = useSelector(
    (state) => state.user.userSettingUpdateSuccess
  );
  const [params, setParams] = useState({
    login: userSettingInfo.login,
    push: userSettingInfo.push,
    sms: userSettingInfo.sms,
    email: userSettingInfo.email,
  });
  const accessToken = getToken();
  const isLogin = returnLoginStatus();
  const userAgent = checkMobile();

  const handleLogout = () => {
    const params = {};
    dispatch(authActions.fetchLogout({ accessToken, params }));
  };

  useEffect(() => {
    getData();
    if (window.ReactNativeWebView) {
      const message = { type: "appVersion", content: `` };
      window.ReactNativeWebView.postMessage(JSON.stringify(message));
    }
  }, []);

  useEffect(() => {
    // React Native로부터 메시지를 받아서 콘솔에 출력하는 이벤트 핸들러 등록
    const handleMessageFromReactNative = (event) => {
      const data = JSON.parse(event.data); // 데이터 파싱
      setVersion(data.appVersion); // 버전 정보 설정
    };

    // 메시지 이벤트 리스너 등록
    if (window.ReactNativeWebView) {
      if (userAgent == "android") {
        //android
        document.addEventListener("message", (e) =>
          handleMessageFromReactNative(e)
        );
        // 컴포넌트 언마운트 시 이벤트 리스너 제거
        return () => {
          window.removeEventListener("message", handleMessageFromReactNative);
        };
      } else {
        //ios , 기타
        document.addEventListener("message", (e) =>
          handleMessageFromReactNative(e)
        );
        return () => {
          window.removeEventListener("message", handleMessageFromReactNative);
        };
      }
    }
  }, []);

  const getData = () => {
    if (isLogin) {
      const params = {};
      dispatch(userActions.fetchUserSetting({ params, accessToken }));
    }
  };
  const returnType = (type) => {
    let resp;
    switch (type) {
      case "push":
        resp = "앱 푸시";
        break;
      case "sms":
        resp = "SMS";
        break;
      case "email":
        resp = "E-mail";
        break;

      default:
        resp = type;
    }
    return resp;
  };
  const handleChangeSetting = (e) => {
    const { id, checked } = e.target;
    setSettingItem(id);
    setParams((prev) => ({
      ...prev,
      [id]: checked,
    }));
    if (id == "login") {
      const newParams = {
        [id]: checked,
        push: userSettingInfo.push,
        sms: userSettingInfo.sms,
        email: userSettingInfo.email,
      };
      dispatch(
        userActions.fetchUserSettingUpdate({ params: newParams, accessToken })
      );
    } else {
      if (checked) {
        setOpenFuncModal(true);
      } else {
        setOpenCancelFuncModal(true);
      }
    }
  };

  const handleUserSettingUpdate = () => {
    dispatch(userActions.fetchUserSettingUpdate({ params, accessToken }));
  };

  useEffect(() => {
    setParams((prev) => ({
      ...prev,
      login: userSettingInfo.login,
      push: userSettingInfo.push,
      sms: userSettingInfo.sms,
      email: userSettingInfo.email,
    }));
  }, [userSettingInfo]);

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);

  return (
    <OnlyHeaderLayout title="설정">
      {openModal && (
        <Modal
          setOpenModal={setOpenModal}
          callbackFunc={
            userSettingUpdateSuccess
              ? () => {
                  setSettingMode(false);
                  getData();
                }
              : () => {
                  return;
                }
          }
        >
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      {openFuncModal && (
        <FuncModal
          title={`‘뮤포인트’ 에서 ${returnType(
            settingItem
          )}  알림을 보내고자 합니다.`}
          setOpenModal={setOpenFuncModal}
          callbackFunc={handleUserSettingUpdate}
          cancelFunc={() => {
            setParams((prev) => ({
              ...prev,
              [settingItem]: false,
            }));
          }}
          cancelText="미동의"
          confirmText="동의"
        >
          <p>
            해당기기로 서비스에 필요한 안내사항을 <br />
            {returnType(settingItem)} 알림으로 보내드리겠습니다.
            <br />
            <br />
            {returnType(settingItem)} 수신을 동의하시겠습니까?
          </p>
        </FuncModal>
      )}
      {openCancelModal && (
        <Modal
          title={`   ${returnType(settingItem)} 알림 수신거부 처리 결과`}
          setOpenModal={setOpenCancelFuncModal}
          callbackFunc={handleUserSettingUpdate}
        >
          <p>
            전송자:뮤포인트
            <br /> 일시:2023년 8월 9일
            <br /> 내용:수신거부 처리 완료
            <br />
            <br />
            {returnType(settingItem)} 알림은 <br />
            메뉴 -{`>`} [설정] 에서 변경 가능합니다.
          </p>
        </Modal>
      )}
      <Section className="nonePaddingTop">
        <SettingContent>
          {isLogin && (
            <div>
              <p>로그인 / 회원정보</p>

              <ul>
                <li>
                  자동로그인
                  <Switch
                    id={"login"}
                    isOn={params.login}
                    handleToggle={handleChangeSetting}
                  />
                </li>
                <li>
                  개인정보 변경
                  <IcoArrow
                    className="pointer"
                    onClick={() => {
                      navigate("/mypage/edit");
                    }}
                  />
                </li>
                <li>
                  로그아웃
                  <IcoArrow onClick={handleLogout} className="pointer" />
                </li>
              </ul>
            </div>
          )}
          {isLogin && (
            <div>
              <p>알림</p>
              <ul>
                <li>
                  푸시 알림
                  <Switch
                    id={"push"}
                    isOn={params.push}
                    handleToggle={handleChangeSetting}
                  />
                </li>
                <li>
                  SMS 알림
                  <Switch
                    id={"sms"}
                    isOn={params.sms}
                    handleToggle={handleChangeSetting}
                  />
                </li>
                <li>
                  E-MAIL 알림
                  <Switch
                    id={"email"}
                    isOn={params.email}
                    handleToggle={handleChangeSetting}
                  />
                </li>
              </ul>
            </div>
          )}

          <VersionInfo>
            <p>버전 정보</p>
            <ul>
              <li>
                <div>현재 버전</div>
                <div>V{version}</div>
              </li>
              <li>
                <div>최신 버전</div>
                <div></div>
              </li>
            </ul>
          </VersionInfo>
        </SettingContent>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default SettingPage;

const SettingContent = styled(Content)`
  padding: 0;
  p {
    padding: 0 4rem;
    height: 8rem;
    line-height: 8rem;
  }
  li {
    background-color: ${({ theme }) => theme.color.white};
    height: 6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4rem;
    font-weight: 700;
  }
`;
const VersionInfo = styled.div`
  padding: 0 3rem 4rem 3rem;
  p {
    padding: 0 1rem;
  }
  ul {
    border-top: 1px solid ${({ theme }) => theme.color.input_text_gray};
    border-bottom: 1px solid ${({ theme }) => theme.color.input_text_gray};
    :nth-child(1) {
      border-top: 0;
    }
  }
  li {
    padding: 0 1rem;
    background-color: transparent;
    border-top: 1px dashed ${({ theme }) => theme.color.input_text_gray};
    font-weight: 400;
    font-size: 1.4rem;
  }
`;
